import React, { useState, useCallback, useRef, useEffect } from "react";
import { StyledRow, StyledCol, IconWrapper, ButtonLabel, DashboardPopup, PopupItem } from "./styled";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faStore, faChartSimple, faEllipsisVertical, faChartLine, faDollarSign, faBagShopping } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation } from "react-router-dom";
import { ROUTE_PATH, ROUTE_PRODUCT_PATH } from "../../constants/routePath";
import MoreModal from '../../components/MoreModal';
import StorePreview from '../../pages/StorePreview';

const BottomNavBar = () => {
    const [isStorePageVisible, setIsStorePageVisible] = useState(false);
    const [isMoreModalVisible, setIsMoreModalVisible] = useState(false);
    const [isDashboardPopupVisible, setIsDashboardPopupVisible] = useState(false);
    const dashboardButtonRef = useRef(null);

    const location = useLocation();
    const currentPath = location.pathname;

    const isStoreActive = [
        ROUTE_PATH.DESIGN, 
        ROUTE_PATH.MYSTORE,
        ROUTE_PATH.USERPROFILE, 
        ROUTE_PATH.PRODUCTS,
        ROUTE_PRODUCT_PATH.URL_PRODUCT, 
        ROUTE_PRODUCT_PATH.TIP_PRODUCT,
        ROUTE_PRODUCT_PATH.CUSTOM_PRODUCT,
        ROUTE_PRODUCT_PATH.DIGITAL_PRODUCT, 
        ROUTE_PRODUCT_PATH.COACHING_CALL, 
        ROUTE_PRODUCT_PATH.EMAIL_PRODUCT,
        ROUTE_PRODUCT_PATH.VIDEO_PRODUCT, 
        ROUTE_PRODUCT_PATH.EDIT_EMAIL_PRODUCT,
        ROUTE_PRODUCT_PATH.EDIT_URL_PRODUCT,
        ROUTE_PRODUCT_PATH.EDIT_VIDEO_PRODUCT,
        ROUTE_PRODUCT_PATH.EDIT_REFERRAL_PRODUCT,
        ROUTE_PATH.REFERRAL_PRODUCT].includes(currentPath);

    const isShopActive = currentPath === ROUTE_PATH.CREATOR_STORE || 
                        currentPath === ROUTE_PATH.CREATOR_STORE_CATEGORIES ||
                        (currentPath.includes('/creator-store') && !isStoreActive);

    const isMoreActive = [
        ROUTE_PATH.PROFILE, 
        ROUTE_PATH.BILLING, 
        ROUTE_PATH.PAYMENTS,
        ROUTE_PATH.CUSTOMERS,
        ROUTE_PATH.PAYMENTS,
        ROUTE_PATH.REFERRALS].includes(currentPath);
    
    const isDashboardActive = 
        currentPath === ROUTE_PATH.INCOME || 
        currentPath === ROUTE_PATH.DASHBOARD;

    const handleOpenStorePage = useCallback(() => {
        setIsStorePageVisible(true);
    }, []);

    const handleCloseStorePage = useCallback(() => {
        setIsStorePageVisible(false);
    }, []);

    const toggleDashboardPopup = (e) => {
        e.preventDefault();
        setIsDashboardPopupVisible(!isDashboardPopupVisible);
    };

    const handlePopupItemClick = () => {
        setIsDashboardPopupVisible(false);
    };
    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dashboardButtonRef.current && !dashboardButtonRef.current.contains(event.target)) {
                setIsDashboardPopupVisible(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <StyledRow justify="space-evenly">
                <StyledCol span={4} onClick={handleOpenStorePage} active="false">
                    <IconWrapper active="false">
                        <FontAwesomeIcon icon={faEye} style={{ fontSize: '18px' }} />
                    </IconWrapper>
                    <ButtonLabel style={{ fontWeight: '400', lineHeight: '20px' }} active="false">Preview</ButtonLabel>
                </StyledCol>
                
                <StyledCol 
                    span={4} 
                    active={isDashboardActive.toString()} 
                    ref={dashboardButtonRef}
                    className="dashboard-button"
                >
                    <div onClick={toggleDashboardPopup}>
                        <IconWrapper active={isDashboardActive.toString()}>
                            <FontAwesomeIcon icon={faChartLine} style={{ fontSize: '18px' }} />
                        </IconWrapper>
                        <ButtonLabel active={isDashboardActive.toString()}>Insights</ButtonLabel>
                    </div>
                    
                    {isDashboardPopupVisible && (
                        <DashboardPopup>
                            <Link to={ROUTE_PATH.INCOME} onClick={handlePopupItemClick}>
                                <PopupItem isActive={currentPath === ROUTE_PATH.INCOME}>
                                    <FontAwesomeIcon icon={faDollarSign} />
                                    <span>Income</span>
                                </PopupItem>
                            </Link>
                            <Link to={ROUTE_PATH.DASHBOARD} onClick={handlePopupItemClick}>
                                <PopupItem isActive={currentPath === ROUTE_PATH.DASHBOARD}>
                                    <FontAwesomeIcon icon={faChartSimple} />
                                    <span>Dashboard</span>
                                </PopupItem>
                            </Link>
                        </DashboardPopup>
                    )}
                </StyledCol>
                
                <StyledCol span={4} active={isStoreActive.toString()}>
                    <Link to={ROUTE_PATH.MYSTORE}>
                        <IconWrapper active={isStoreActive.toString()}>
                            <FontAwesomeIcon icon={faStore} style={{ fontSize: '18px' }} />
                        </IconWrapper>
                        <ButtonLabel active={isStoreActive.toString()}>My Page</ButtonLabel>
                    </Link>
                </StyledCol>
                  <StyledCol span={4} active={isShopActive.toString()}>
                    <Link to={ROUTE_PATH.CREATOR_STORE}>
                        <IconWrapper active={isShopActive.toString()}>
                            <FontAwesomeIcon 
                                icon={faBagShopping} 
                                style={{ fontSize: '18px' }} />
                        </IconWrapper>
                        <ButtonLabel active={isShopActive.toString()}>
                            Shop
                        </ButtonLabel>
                    </Link>
                </StyledCol>
                
                <StyledCol span={4} active={isMoreActive ? "true" : "false"} onClick={() => setIsMoreModalVisible(true)}>
                    <IconWrapper active={isMoreActive ? "true" : "false"}>
                        <FontAwesomeIcon icon={faEllipsisVertical} style={{ fontSize: '18px' }} />
                    </IconWrapper>
                    <ButtonLabel
                        style={{ fontWeight: '400', lineHeight: '20px' }}
                        active={isMoreActive ? "true" : "false"}
                        bold="true"
                    >
                        More
                    </ButtonLabel>
                </StyledCol>
            </StyledRow>

            <MoreModal
                open={isMoreModalVisible}
                onClose={() => setIsMoreModalVisible(false)}
            />

            <StorePreview
                onClose={handleCloseStorePage}
                isVisible={isStorePageVisible}
            />
        </>
    );
};

export default BottomNavBar;